import React from 'react';
export function BdFlag({
  width = 30,
  className
}: {
  width?: number;
  className?: string;
}) {
  return <svg width={width} height={width * 3 / 5} viewBox="0 0 50 30" className={className} role="img" aria-label="বাংলাদেশের পতাকা" data-id="element-166" data-mp="9a0zrt0z9n84">
      <rect width="50" height="30" fill="#006A4E" rx="2" data-id="element-167" data-mp="naleoe3ruywc" />
      <circle cx="22.5" cy="15" r="9.5" fill="#F42A41" data-id="element-168" data-mp="i9e7ag5jk1q7" />
    </svg>;
}